import React from 'react';
import './Loader.css';

const Loader = () => (
  <div className="pop-loader" role="status" aria-label="Loading">
    <div className="pop-loader__container" aria-hidden="true">
      <span className="pop-loader__ring" />
      <span className="pop-loader__glow" />
      <img
        className="pop-loader__logo"
        src={`${process.env.PUBLIC_URL}/edvergenex_logo.png`}
        alt=""
      />
      <span className="pop-loader__label">Loading</span>
    </div>
  </div>
);

export default Loader;
